import { IPromise } from 'angular';
import { Action } from '../../actions/core/action';
import ActionDispatcherService from '../../actions/core/action-dispatcher.service';
import { ActionHandler } from '../../actions/core/action-handler';
import UserService from '../user/user.service';
import { AuthGrantedAction, AuthRevokedAction } from './auth.action';
import { LanguageChangeAction } from '../../actions/language.action';
import HttpService from '../http.service';

export enum DataModifyingEvent {
  INIT,
  POST_LINK,
  AUTH_CHANGED,
  INIT_AUTH_CHANGED,
  POST_LINK_AUTH_CHANGED
}
// TODO: Merve. Do we need AuthAwareController at all? Do we have cases when unauthorized user can access to credit-cards?
export default abstract class AuthAwareController implements ActionHandler {
  private registeredInActionDispatcher;

  constructor(
    protected actionDispatcher: ActionDispatcherService,
    protected userService: UserService,
    protected httpService: HttpService,
    protected dataModifyingEvent: DataModifyingEvent = DataModifyingEvent.INIT_AUTH_CHANGED
  ) {}

  public $onInit() {
    if (
      this.dataModifyingEvent === DataModifyingEvent.AUTH_CHANGED ||
      this.dataModifyingEvent === DataModifyingEvent.INIT_AUTH_CHANGED ||
      this.dataModifyingEvent === DataModifyingEvent.POST_LINK_AUTH_CHANGED
    ) {
      this.actionDispatcher.register(this);
      this.registeredInActionDispatcher = true;
    }

    if (
      this.dataModifyingEvent === DataModifyingEvent.INIT ||
      this.dataModifyingEvent === DataModifyingEvent.INIT_AUTH_CHANGED
    ) {
      this.initData();
    }
  }

  public $postLink() {
    if (
      this.dataModifyingEvent === DataModifyingEvent.POST_LINK ||
      this.dataModifyingEvent === DataModifyingEvent.POST_LINK_AUTH_CHANGED
    ) {
      this.initData();
    }
  }

  public $onDestroy() {
    if (this.registeredInActionDispatcher) {
      this.actionDispatcher.unregister(this);
    }
  }

  public handle(action: Action) {
    if (action instanceof AuthGrantedAction) {
      this.loadAuthDependentData();
    }
    if (action instanceof AuthRevokedAction) {
      this.resetAuthDependentData();
    }
    if(action instanceof LanguageChangeAction && action.reloadAuthData){
      this.initData();
    }
  }

  protected isAuthenticated(): IPromise<boolean> {
    return this.userService.isAuthenticated();
  }

  protected abstract loadAuthDependentData();

  protected abstract resetAuthDependentData();

  protected initData() {
    this.isAuthenticated().then(result => {
      if (result === true) {
        this.httpService.promiseCache['listeningPackage'] = null;
        this.loadAuthDependentData();
      } else {
        this.resetAuthDependentData();
      }
    });
  }
}



// WEBPACK FOOTER //
// src/app/common/services/auth/auth-aware.controller.ts